module.exports = __webpack_public_path__ + "img/guide-02.d2c5414c.jpg";